export default __webpack_public_path__ + "static/media/crypto_light.d4118656.png";